export const DEFAULT_LANGUAGE = 'en';
export const FALLBACK_LANGUAGE = 'en';
export const SUPPORTED_LANGUAGES = ['ar','br','da','de','en','es','fi','fr','it','ja','ko','nl','no','pl','pt','ru','sv','tr','tw','zh'];



// WEBPACK FOOTER //
// ./src/constants/trans.js